import { type FC } from "react";
import { Button } from "@chakra-ui/react";
import { type GlobalDictionary } from "../../dictionary";
import { useTranslation } from "~/foundation/Dictionary";

interface LoadMoreProps {
	totalResults: number;
	numberOfResults: number;
	page: number;
	setPage: (page: number) => void;
	loading?: boolean;
}

const LoadMore: FC<LoadMoreProps> = ({
	page,
	setPage,
	loading
}) => {
	const [t] = useTranslation<GlobalDictionary>();

	return (
		<Button
			variant="dark"
			size="lg"
			onClick={() => setPage(page + 1)}
			isLoading={loading}
		>
			{t("search.loadMore")}
		</Button>
	)
}

export { LoadMore };